export const TOTAL_TRANSACTION_VIA = 5;